import Image from "components/Image"
import Container from "../../components/Container"
import Title from "../../components/Title"

import "./Benefits.scss"

const cards = [
  {
    title: "Seu nome limpo no Itaú após o primeiro pagamento",
    subtitle: "Seu nome limpo em até 5 dias úteis.",
  },
  {
    title: "Parcelas que cabem no seu bolso",
    subtitle: "Parcelamento flexível em até 72x.",
  },
  {
    title: "Faça sua renegociação online",
    subtitle: "Renegocie de onde estiver pelos nossos canais digitais.",
  },
]

const Benefits = () => {
  return (
    <section className="landing-benefits">
      <Container className="landing-benefits__container">
        <Title className="landing-benefits__title --mobile">
          Conheça os benefícios
        </Title>

        <Image
          src="/images/landing/benefits.png"
          className="landing-benefits__image"
          alt="Mulher sorrindo usando o celular"
        />

        <div className="landing-benefits__content">
          <Title className="landing-benefits__title --desktop">
            Conheça os benefícios
          </Title>

          <div className="landing-benefits__cards">
            {cards.map((card) => {
              return (
                <div key={card.title} className="landing-benefits__card">
                  <h3 className="landing-benefits__card-title">{card.title}</h3>
                  <p className="landing-benefits__card-subtitle">
                    {card.subtitle}
                  </p>
                </div>
              )
            })}
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Benefits
